import { render, staticRenderFns } from "./LuckyHistory.vue?vue&type=template&id=e4ba6b6e&scoped=true&"
import script from "./LuckyHistory.vue?vue&type=script&lang=js&"
export * from "./LuckyHistory.vue?vue&type=script&lang=js&"
import style0 from "./LuckyHistory.vue?vue&type=style&index=0&id=e4ba6b6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ba6b6e",
  null
  
)

export default component.exports